function samplepage1() {
  return (
    <div>
      <h1>Sample Page</h1>
    </div>
  );
}

export default samplepage1;
